import FJActionConstant from "../../constant/FJActionConstant";
import {FJMediaAction, FJModalAction} from "./FJRoot.action";
import FJCoreUtil from "../../core/util/FJCoreUtil";
import FJNetworkStore from "../../store/FJNetworkStore";
import FJCoreConstant from "../../core/constant/FJCoreConstant";
import FJViewConstant from "../../constant/FJViewConstant";
import FJUtil from "../../util/FJUtil";
import FJMedia from "../../store/FJMedia";
import FJEventConstant from "../../constant/FJEventConstant";

let FJStockVideoAction = (function () {

	return {

		/**
		 * @description 打开 StockVideo 面板
		 * @returns {function(...[*]=)}
		 */
		showStockVideoPanelAction: function () {
			return (dispatch) => {
				FJCoreUtil.triggerBodyMousedown();
				dispatch(FJModalAction.setIsShowStockVideoModelAction(true))
			}
		},

		/**
		 * @description 设置当前栏目
		 * @param type
		 * @returns {{activeOption: *, type: string}}
		 */
		setActiveOptionAction: function (type) {
			return {
				type: FJActionConstant.CUT_STOCK_VIDEO_OPTION,
				activeOption: type
			}
		},

		clearImageSearchAction: function () {
			return (dispatch) => {
				dispatch(this.setImageStatusAction({
					searchImageKeyword: '',
					imagePanelType: 1,
					searchImageMode: FJViewConstant.STOCK_SEARCH_SUCCESS,
					searchImages: [],
				}));
			};
		},

		clearVideoSearchAction: function () {
			return (dispatch) => {
				dispatch(this.setStockVideoStatusAction({
					searchVideoKeyword: '',
					videoPanelType: 1,
					searchVideoMode: FJViewConstant.STOCK_SEARCH_SUCCESS,
					searchVideos: [],
				}));
			};
		},

		searchVideoWithBKAction: function (keywords) {
			return (dispatch, getState) => {
				let sortType = getState().stock.searchVideoSortType;
				dispatch(this.setActiveOptionAction(FJViewConstant.STOCK_VIDEO_VIDEO));
				dispatch(this.searchVideoAction(keywords, sortType, 1));
			};
		},

		searchVideoAction: function (keywords, sortType, page) {
			return (dispatch, getState) => {
				let status = {
					searchVideoKeyword: keywords,
					searchVideoSortType: sortType,
					searchVideoPage: page,
					videoPanelType: 2,
				};
				let transKeywords = FJUtil.filterInvalidWord(keywords).toLowerCase();
				switch (page) {
					case 1:
						status.searchVideoMode = FJViewConstant.STOCK_SEARCH_LOADING;
						status.searchVideos = [];
						break;
					default:
						status.searchVideoMode = FJViewConstant.STOCK_SEARCH_SUBLOADING;
				}
				dispatch(this.setStockVideoStatusAction(status));

				let searchTag = keywords + sortType + page;
				let getCurSearchTag = (getState) => {
					let {searchVideoKeyword, searchVideoSortType, searchVideoPage} = getState().stock;
					return searchVideoKeyword + searchVideoSortType + searchVideoPage;
				};

				FJNetworkStore.searchMedias({
					type: FJCoreConstant.VIDEO,
					keywords: transKeywords,
					page,
					sortType,
				}).then(arg => {
					let videos = getState().stock.searchVideos.concat(arg[0]);
					if (videos.length > 0) {
						FJUtil.addSearchHistory(FJViewConstant.SEARCH_STOCK_VIDEO, transKeywords);
					}
					if (getCurSearchTag(getState) === searchTag) {
						dispatch(this.setStockVideoStatusAction({
							searchVideos: videos,
							searchVideoTotal: arg[1],
							searchVideoMode: FJViewConstant.STOCK_SEARCH_SUCCESS,
							searchVideoPage: page,
							searchVideoHistory: FJUtil.getSearchHistory(FJViewConstant.SEARCH_STOCK_VIDEO),
						}));
					}
				}).catch(e => {
					console.log(e);
					if (getCurSearchTag(getState) === searchTag) {

						// page等于1时是第一次搜索，失败显示失败界面
						// 不等于1时失败只取消loading状态
						if (page === 1) {
							dispatch(this.setStockVideoStatusAction({
								searchVideos: [],
								searchVideoTotal: 0,
								searchVideoMode: FJViewConstant.STOCK_SEARCH_ERROR,
							}));
						} else {
							dispatch(this.setStockVideoStatusAction({
								searchVideoMode: FJViewConstant.STOCK_SEARCH_SUCCESS,
							}));
						}
					}
				})
			};
		},

		searchImageAction: function (keywords, page) {
			return (dispatch, getState) => {
				let status = {
					searchImageKeyword: keywords,
					searchImagePage: page,
					imagePanelType: 2,
				};
				let transKeywords = FJUtil.filterInvalidWord(keywords).toLowerCase();
				switch (page) {
					case 1:
						status.searchImageMode = FJViewConstant.STOCK_SEARCH_LOADING;
						status.searchImages = [];
						break;
					default:
						status.searchImageMode = FJViewConstant.STOCK_SEARCH_SUBLOADING;
				}
				dispatch(this.setImageStatusAction(status));

				let searchTag = keywords + page;
				let getCurSearchTag = (getState) => {
					let {searchImageKeyword, searchImagePage} = getState().stock;
					return searchImageKeyword + searchImagePage;
				};

				FJNetworkStore.searchMedias({
					type: FJCoreConstant.IMAGE,
					keywords: transKeywords,
					page,
				}).then(arg => {
					let images = getState().stock.searchImages.concat(arg[0]);
					if (images.length > 0) {
						FJUtil.addSearchHistory(FJViewConstant.SEARCH_STOCK_IMAGE, transKeywords);
					}
					if (getCurSearchTag(getState) === searchTag) {
						dispatch(this.setImageStatusAction({
							searchImages: images,
							searchImageTotal: arg[1],
							searchImageMode: FJViewConstant.STOCK_SEARCH_SUCCESS,
							searchImagePage: page,
							searchImageHistory: FJUtil.getSearchHistory(FJViewConstant.SEARCH_STOCK_IMAGE),
						}));
					}
				}).catch(e => {
					console.log(e);
					if (getCurSearchTag(getState) === searchTag) {

						// page等于1时是第一次搜索，失败显示失败界面
						// 不等于1时失败只取消loading状态
						if (page === 1) {
							dispatch(this.setImageStatusAction({
								searchImages: [],
								searchImageTotal: 0,
								searchImageMode: FJViewConstant.STOCK_SEARCH_ERROR,
							}));
						} else {
							dispatch(this.setImageStatusAction({
								searchImageMode: FJViewConstant.STOCK_SEARCH_SUCCESS,
							}));
						}
					}
				})
			};
		},

		searchAudioAction: function (keywords, sortType, page, filter) {
			return (dispatch, getState) => {
				let shouldSearch = keywords.trim() !== '' || filter.mood || filter.genre || filter.instrument
					|| filter.duration[0] !== 0 || filter.duration[1] !== 240
				;
				let status = {
					searchAudioKeyword: keywords,
					searchAudioSortType: sortType,
					searchAudioFilter: filter,
					searchAudioPage: page,
					audioPanelType: shouldSearch ? 2 : 1,
				};
				let transKeywords = FJUtil.filterInvalidWord(keywords).toLowerCase();
				dispatch(this.setStockAudioStatusAction(status));
				if (shouldSearch) {
					switch (page) {
						case 1:
							status.searchAudioMode = FJViewConstant.STOCK_SEARCH_LOADING;
							status.searchAudios = [];
							break;
						default:
							status.searchAudioMode = FJViewConstant.STOCK_SEARCH_SUBLOADING;
					}
					dispatch(this.setStockAudioStatusAction(status));

					let searchTag = keywords + sortType + page + JSON.stringify(filter);
					let getCurSearchTag = (getState) => {
						let {searchAudioKeyword, searchAudioSortType, searchAudioPage, searchAudioFilter} = getState().stock;
						return searchAudioKeyword + searchAudioSortType + searchAudioPage + JSON.stringify(searchAudioFilter);
					};

					FJNetworkStore.searchMedias({
						type: FJCoreConstant.AUDIO,
						keywords: transKeywords,
						page,
						sortType,
						genres: filter.genre,
						moods: filter.mood,
						instruments: filter.instrument,
						durationRange: filter.duration,
						filter,
					}).then(arg => {
						let audios = getState().stock.searchAudios.concat(arg[0]);
						if (audios.length > 0) {
							FJUtil.addSearchHistory(FJViewConstant.SEARCH_STOCK_MUSIC, transKeywords);
						}
						if (searchTag === getCurSearchTag(getState)) {
							dispatch(this.setStockAudioStatusAction({
								searchAudios: audios,
								searchAudioTotal: arg[1],
								searchAudioMode: FJViewConstant.STOCK_SEARCH_SUCCESS,
								searchAudioPage: page,
								searchAudioFilter: filter,
								searchAudioHistory: FJUtil.getSearchHistory(FJViewConstant.SEARCH_STOCK_MUSIC),
							}));
						}
					}).catch(e => {
						console.log(e);
						if (searchTag === getCurSearchTag(getState)) {

							// page等于1时是第一次搜索，失败显示失败界面
							// 不等于1时失败只取消loading状态
							if (page === 1) {
								dispatch(this.setStockAudioStatusAction({
									searchAudios: [],
									searchAudioTotal: 0,
									searchAudioMode: FJViewConstant.STOCK_SEARCH_ERROR,
								}));
							} else {
								dispatch(this.setStockAudioStatusAction({
									searchAudioMode: FJViewConstant.STOCK_SEARCH_SUCCESS,
								}));
							}
						}
					})
				}
			};
		},

		deleteVideoHistoryAction: function (type) {
			return (dispatch) => {
				FJUtil.clearSearchHistory(type)
				let data = {}
				switch (type) {
					case FJViewConstant.SEARCH_STOCK_VIDEO:
						data.searchVideoHistory = []
						break;
					case FJViewConstant.SEARCH_STOCK_IMAGE:
						data.searchImageHistory = []
						break;
					case FJViewConstant.SEARCH_STOCK_MUSIC:
						data.searchAudioHistory = []
				}
				dispatch(this.setStockVideoStatusAction(data));
			}
		},

		/**
		 * @description
		 * @param data
		 * @param data.searchVideoPage
		 * @param data.searchVideoSortType
		 * @param data.searchVideoLoading
		 * @param data.searchVideoSubLoading
		 * @param data.searchVideoKeyword
		 * @param data.searchVideos
		 * @param data.searchVideoHistory
		 * @param data.videoPanelType
		 * @param data.searchVideoError
		 * @return {{data, type: string}}
		 */
		setStockVideoStatusAction: function (data) {
			return {
				type: FJActionConstant.SET_STOCK_VIDEO_STATUS,
				data,
			}
		},

		/**
		 * @description
		 * @param data
		 * @param data.searchVideoPage
		 * @param data.searchVideoSortType
		 * @param data.searchVideoLoading
		 * @param data.searchVideoSubLoading
		 * @param data.searchVideoKeyword
		 * @param data.searchVideos
		 * @param data.searchVideoHistory
		 * @param data.videoPanelType
		 * @param data.searchVideoError
		 * @return {{data, type: string}}
		 */
		setImageStatusAction: function (data) {
			return {
				type: FJActionConstant.SET_STOCK_IMAGE_STATUS,
				data,
			}
		},

		setStockAudioStatusAction: function (data) {
			return {
				type: FJActionConstant.SET_STOCK_AUDIO_STATUS,
				data,
			}
		},

		/**
		 * @description 关闭 stockvideo 模态框
		 * @returns {function(...[*]=)}
		 */
		closeStockVideoModalAction: function () {
			return (dispatch) => {
				dispatch(FJModalAction.setIsShowStockVideoModelAction(false))
			}
		},

		/**
		 * @description 设置 stock 详情模态框参数
		 * @param data
		 * @returns {{data: *, type: string}}
		 */
		setStockDetailModalAction: function (data) {
			return {
				type: FJActionConstant.SHOW_STOCK_DETAILS_MODAL,
				data
			}
		},

		/**
		 * @description 关闭详情模态框
		 * @returns {{type: string}}
		 */
		hideStockDetailModalAction: function (data) {
			return {
				type: FJActionConstant.HIDE_STOCK_DETAILS_MODAL,
				data,
			}
		},

		toggleStockMediaAction: function (id, type, fromType, toggle, url, options) {
			return (dispatch) => {
        let onSubmit = options && options.onSubmit;
        let onCancel = options && options.onCancel;
        if (toggle) {
					dispatch(FJMediaAction.addNetMediaAction(id, '', type, fromType || FJMedia.MediaFromType().STOCK, options));
          window.FJEvent.dispatch(FJEventConstant.SHOW_STOCK_TIP, !toggle);
          if (onSubmit) onSubmit(true);
				} else {
					dispatch(FJMediaAction.deleteMediaAction(id, onCancel, () => {
            window.FJEvent.dispatch(FJEventConstant.SHOW_STOCK_TIP, !toggle);
            if (onSubmit) onSubmit(true);
          }));
				}
				dispatch(FJMediaAction.updateMediasAction());
			};
		}
	}

})();

export default FJStockVideoAction;